import { AssetRes, AssetType } from "api/assets";
import { AdMaterialDetails, Permission } from "api/creatives";

export interface Asset {
    assigned: boolean;
    bigPreview?: AdMaterialDetails;
    creationDate: string;
    current: boolean;
    deleted: boolean;
    height: string;
    id: number;
    inputFileName: string;
    mimeType: string;
    modificationDate: string;
    name: string;
    originalFile: AdMaterialDetails;
    permissions: Permission[];
    preview?: AdMaterialDetails;
    processing: boolean;
    products: [];
    size: string;
    status: string;
    valid: boolean;
    width: string;
    type: AssetType;
}

export const buildAssetViewModel = async (res: Promise<AssetRes[]>): Promise<Asset[]> => {
    const assets = await res;

    return assets.map((history) => {
        return {
            assigned: history.assigned,
            bigPreview: history.bigpreview,
            creationDate: history.creationdate,
            current: history.current,
            deleted: history.deleted,
            height: history.height,
            id: history.id,
            inputFileName: history.inputfilename,
            mimeType: history.mimetype,
            modificationDate: history.modificationdate,
            name: history.name,
            originalFile: history.originalfile,
            permissions: history.permissions,
            preview: history.preview,
            processing: history.processing,
            products: history.products,
            size: history.size,
            status: history.status,
            valid: history.valid,
            width: history.width,
            type: history.type,
        };
    });
};
